import { ref } from "vue";
import ChatService from "../../core/core/chat/ChatService";
import MindmapSDKSubjectNode from "./MindmapSDKSubjectNode";
import Util from "../../utils/Util";

class SDKChatVM {
    constructor(isElectron = true) {
        this.chatService = new ChatService(isElectron, 'https://todo.mindyushu.com');
        this.messageIdPoint = -1
        this.loading = false;
        this.messages = ref([]);
        this.inputMessage = ref('');
        this.messagesContainer = ref(null);
        this.isStreaming = ref(false);
        this.isElectron = isElectron;
        this.deleagte = null;
        this.sdkData = null;
        this.firstLevelSeparatedBy = "|";
        this.secondLevelSeparatedBy = "--";

        this.isTestData = false;
        this.valueIndex = 0;
        this.chatId = -1;
    }

    loadData() {
    }

    updateUiMessages(isScrollToBottom = true) {        
    }

    onFormatCompleted(isOk, mindId) {
        if (!isOk) {
            return
        }
        let node = new MindmapSDKSubjectNode().format()
        // this.deleagte.showMessage("转化成功") 
        this.updateUiMessages(false);
    }
    
    error(message) {
        this.deleagte.showError(message)       
    }

    messageToMap(message, isCompleted) {
        if (message.length == 0 || !isCompleted || this.chatId == -1) {        
            return;
        }
        // console.log("message-> ", message);
        this.chatId = -1
        let node = new MindmapSDKSubjectNode().format(message)
        this.sdkData.rootNode = node
        this.deleagte.onAiCompleted(this.sdkData)  
        this.loading = false;
        this.isStreaming.value = false;
    }

    sendMessageToAiForMap(message, customPrompt = "") {
        if (this.isEmpty(message)) {
            this.deleagte.showError("消息不能为空") 
            return;
        }
        if (message.length > 5000) {
            this.deleagte.showError("内容超过5000字，超出限制") 
            return;
        }
        this.updateUiMessages(true)
        
        this.sendChatMessageToAiForMap(message, customPrompt); 
    }

    sendChatMessageToAiForMap(message, customPrompt = "") {
        let tip1 = "请将下方的内容，帮我转化为思维导图。要求：\n";
        let prompt1 = "1、其中中心主题控制在10个字以内，主题控制在12个字以内，子主题控制的20个字以内;\n";
        let prompt2 = "2、请直接返回json格式，方便我后续处理：{\"value\":{\"text\": \"中心主题\"},\"children\":[{\"value\":{\"text\": \"主题1\"},\"children\":[{\"value\":{\"text\": \"子主题1\"},\"children\":[]}]},{\"value\":{\"text\": \"主题二\"},\"children\":[]}]}\n";
        let prompt3 = "3、返回给我的仅一个符合 JSON 规范的对象，不得包含任何解释、前言、后缀或 Markdown 代码块。\n"; 
        if (customPrompt != null && customPrompt.length > 0) {
            prompt3 += "4、" + customPrompt + "\n"
        }       
        let tip2 = "分析转思维导图内容：【" + message + "】";
        let chatMessage = tip1 + prompt1 + prompt2 + prompt3 + "\n" + tip2;
        // console.log("chatMessage-> ", chatMessage);        
        this.sendMessage(chatMessage, "deepseek-v3.1");
    }

    isEmpty(str) {
        return str == null || str.length == 0;
    }

    setLoadingStatus() {        
        if (this.deleagte != null) {
            this.deleagte.setChatLoading(this.loading)
        }
    }

    sendMessage(message, model) {
        // console.log("sendMessage-> ", this.loading);
        if (message.length > 5300) {
            this.deleagte.showError("内容超过5000字，超出限制") 
            return;
        }
        if (!message || this.loading) {
            return;
        }
        // 添加用户消息
        this.messages.value.push({
            role: 'user',
            content: message,
            timestamp: new Date(),
        });
        
        // 添加AI消息占位
        this.messages.value.push({
            role: 'assistant',
            content: '',
            timestamp: new Date(),
        });
        let that = this
        this.loading = true;
        this.isStreaming.value = true;
        this.setLoadingStatus()
        
        try {
            this.chatId = Util.getCurrentTime()
            this.chatService.sendMessage({
                message,
                model: model,
                userId: "",
            },
            // 数据块回调
            (chunk) => {
                const lastIndex = that.messages.value.length - 1;
                that.messages.value[lastIndex].content += chunk;
                that.messageToMap(that.messages.value[lastIndex].content, false);
                // console.log('data chunk->', chunk);
                // console.log('data content->', that.messages.value[lastIndex].content);
            },
            // 完成回调
            () => {
                const lastIndex = that.messages.value.length - 1;
                that.messageToMap(that.messages.value[lastIndex].content, true);
                that.loading = false;
                that.isStreaming.value = false;                
                // console.log('completed content->', that.messages.value[lastIndex].content);
                that.setLoadingStatus()
            },
            // 错误回调
            (error) => {
                // console.error('Stream error:', error);
                var lastIndex = that.messages.value.length - 1;
                that.messages.value[lastIndex].content += `\n[错误: ${error.message}]`;
                that.messageToMap(that.messages.value[lastIndex].content, true);
                this.chatId = -1
                that.loading = false;
                that.isStreaming.value = false;
                that.setLoadingStatus()
            }
            );
        } catch (error) {
            // console.error('Request error:', error);
            if (error.name !== 'AbortError') {
                const lastIndex = that.messages.value.length - 1;
                that.messages.value[lastIndex].content = '请求失败，请重试。';
                that.messageToMap(that.messages.value[lastIndex].content, true);
            }
            this.chatId = -1
            that.loading = false;
            that.isStreaming.value = false;
            that.setLoadingStatus()
        } finally {
            that.loading = false;
            that.isStreaming.value = false;
            that.setLoadingStatus()
        }
  
    }

    testToMap() {
    }

    createATagJump(url) {
    }

    clearDates() {      
    }
}

export default SDKChatVM